import _ from 'lodash';
import * as members from '../../../privates/privateMembers';
import platformUtils from '../../../privates/platformUtils';

function setStyle(styleParam, value) {
    const RMI = members._RMI.get(this);
    const compId = members._compId.get(this);
    const viewerType = members._type.get(this).viewerType;

    const style = RMI.getStyle(compId);
    const param = platformUtils.getWidgetUtils().convertStyleParamForViewerType(viewerType, styleParam);

    const updateStyle = _.set(style, `style.properties.${param}`, value);
    return RMI.setStyle(compId, updateStyle);
}

function getStyleParamValue(styleParam) {
    const RMI = members._RMI.get(this);
    const compId = members._compId.get(this);
    const compStyle = RMI.getStyle(compId);
    const viewerType = members._type.get(this).viewerType;
    const param = platformUtils.getWidgetUtils().convertStyleParamForViewerType(viewerType, styleParam);
    return _.get(compStyle, `style.properties.${param}`);
}

export default {
    setStyle, getStyleParamValue
};
